const initialState = {
  isLoading: false,
  patient: {},
  patientsList: {},
  newUser: {},
  currentData: {},
  details: {},
  errors: null,
  bookingData: {},
};

const patientReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_Patients_req":
      return {
        ...state,
        isLoading: true,
      };
    case "get_Patients_sucesss":
      return {
        ...state,
        isLoading: false,

        patientsList: action.payload,
      };
    case "get_Patients_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "patient_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "patient_List_Success":
      return {
        ...state,
        isLoading: false,
        patient: action.payload,
      };
    case "patient_List_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "patient_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "patient_delete":
      return {
        ...state,
        isLoading: false,
        patient: action.payload,
      };
    case "patient_delete_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "add_patient_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_patient_success":
      return {
        ...state,
        isLoading: false,
        newUser: action.payload,
      };
    case "add_patient_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "edit_patient_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_patient_success":
      return {
        ...state,
        isLoading: false,
        newUser: action.payload,
      };
    case "edit_patient_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "set_patient_details":
      return {
        ...state,
        loading: false,
        currentData: action.payload,
      };
    case "reset_patient_details":
      return {
        ...state,
        loading: false,
        currentData: {},
      };
    case "set_Current_ser_details":
      return {
        ...state,
        laoding: false,
        currentData: action.payload,
      };
    case "set_Booking_Details":
      return {
        ...state,
        laoding: false,
        bookingData: action.payload,
      };
    case "reset_facility_details":
      return {
        ...state,
        laoding: false,
        currentData: {},
      };
    default:
      return state;
  }
};

export { patientReducer };
